module.exports = __webpack_public_path__ + "img/write_icon.6ad4e835.svg";